<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-19 10:18:56
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-01-06 10:14:55
-->
<template>
	<div class="exportList flex flex-align-center">
		<el-button @click="skipRecord">导出记录</el-button>
		<el-button @click="exportFun">导出</el-button>
		<export-dialog ref="exportDialog" :isExportImg="isExportImg" :isExportSku="isExportSku"></export-dialog>
	</div>
</template>
<script>
import exportDialog from './export.vue';
export default {
	components: {
		exportDialog,
	},
	props: {
		routerPath: {
			type: String,
			default: '',
		},
		platformId: {
			type: [Number, String],
			default: '' || 1,
		},
		exportInterface: {
			type: Function,
			default: () => {},
		},
		exportDialog: {
			type: Function,
			default: () => {},
		},
		reversal: {
			type: Boolean,
			default: true,
		},
		//是否支持导出图片
		isExportImg: {
			type: Boolean,
			default: false,
		},
		isExportSku: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		skipRecord() {
			const { routerPath, platformId: platform_id } = this;
			const handLink = this.$router.resolve({
				path: routerPath,
				query: { platform_id },
			});
			window.open(handLink.href, '_blank');
		},
		exportFun() {
			this.exportInterface(this);
		},
	},
};
</script>
<style lang="less" scoped></style>
